export default function isNameValid(name: string) {
  return !(!name || !/^[a-zA-Z '-]{2,30}$/i.test(name));
}